import { Fragment } from 'react';
import VideoDisplay from './video';
import { OptionsDisplay } from './options';

const InfoDisplay = ({ images, lang, links }) => (
   <Fragment>
      <OptionsDisplay images={images} lang={lang} links={links} />
      <VideoDisplay links={links} />
   </Fragment>
);

export default InfoDisplay;
